<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="key" @input="closeInput")
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .columns
          label Name
            input(type="text", v-model="body.name")
        .columns
          label Description
            input(type="text", v-model="body.description")
        .columns
          label Percentage
            input(type="number", v-model="body.percentage")
        //.columns
          label Group
            select(v-model="clientType.type")
              option PRIVATE
              option BUSINESS
              option MAINTENANCE

      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel
</template>
<script type="text/babel">
import ModalReveal from '../../foundation/ModalReveal'
import EditReportingType from '../../../../pages/backoffice/EditReportingType'
import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
import ActionButton from '../ActionButton';

export default {
  name: 'VatButtonModal',
  components: {ActionButton, EditReportingType, ModalReveal},
  data() {
    return {
      body: {
        name: null,
        description: null,
        percentage: null,
      },
      clientType: {
        name: null,
        type: 'PRIVATE'
      },
      key:0
    }
  },
  created() {
  },
  methods: {
    closeInput(event) {
      if(!event) {
        this.key++
        this.body = {}
      }
    },
    save() {
      return KeplerBackofficeSdk.vats.make(this.body, () => {
        this.key++
        this.body = {}
        this.$refs[this.componentId].close()
        this.$store.dispatch('loadVat')
        location.reload()
      })
    }
  },
  computed: {
    componentId() {
      return `vatReveal-${this._uid}`
    },

  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VatButtonModal.vue?f349fbea